/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-13 01:57:30 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 15:42:54
 */

 
// 公共模块
import apiPage from './apiPage'
import fetchDataPage from './fetchDataPage'
import routerPage from './routerPage'


let api = apiPage
let fetch = fetchDataPage
let router = routerPage

// ------------------------------
// ***** zhengxiaowen start *****
// ------------------------------

// 测试模块1
import * as devDemo from './devDemo/config/index'
api = Object.assign(api, devDemo.api)
fetch = Object.assign(fetch, devDemo.fetch)
router = router.concat(devDemo.router)

// 测试模块2
import * as devDemo2 from './devDemo2/config/index'
api = Object.assign(api, devDemo2.api)
fetch = Object.assign(fetch, devDemo2.fetch)
router = router.concat(devDemo2.router)


// ------------------------------
// ***** zhengxiaowen end *****
// ------------------------------

// ------------------------------
// ***** llq start *****
// ------------------------------

// srm模块
import * as srm from './srm/config/index'
api = Object.assign(api, srm.api)
fetch = Object.assign(fetch, srm.fetch)
router = router.concat(srm.router)


// ------------------------------
// ***** llq end *****
// ------------------------------


export {
    api,
    fetch,
    router,
}


// WEBPACK FOOTER //
// ./src/page/index.js